// The audio stream's planted defects (gates D2.3 and D2.4), beside what they break: the stand-in cutscene's second
// AudioContext (cutscene.ts), the growl's caption (content.ts strips it). The engine's own (the limiter, the
// ducking, and since the music pass the music's: voice leading, the motif, the chord, the seed, the layer entries, the
// dynamics, the multisamples, the reverb, the room's level) are @rpg/audio's MIXER_FAULTS, MUSIC_FAULTS,
// INSTRUMENT_FAULTS and REVERB_FAULTS; this module joins them under `?faults=` names in index.ts.

/** The planted defects the audio owns, by their `?faults=` names. */
export const AUDIO_FAULT_NAMES = [
  "audio-second-context",
  "important-sound-no-caption",
  "audio-limiter-bypassed",
  "audio-no-ducking",
  "music-no-voice-leading",
  "music-no-motif",
  "music-stale-chord",
  "music-unseeded",
  "music-all-at-once",
  "music-flat",
  "music-no-multisample",
  "music-no-reverb",
  "music-room-unnormalised",
] as const;

/** The spike's own switches (the engine's are MIXER_FAULTS, MUSIC_FAULTS, INSTRUMENT_FAULTS and REVERB_FAULTS). */
export const AUDIO_FAULTS = {
  /** A cutscene's score makes a second AudioContext of its own (D2.4's planted defect). */
  secondContext: false,
  /** The growl keeps its important flag and loses its caption (D2.3's planted defect). */
  noCaption: false,
};

/** The important cue the caption defect strips. */
export const UNCAPTIONED_CUE = "enemy.growl";
